import styled, { css } from 'styled-components';

interface CardWrapperProps {
  showMobile?: boolean;
}

export const CardWrapper = styled.button<CardWrapperProps>`
  background: transparent;
  margin-inline: 0;
  padding: 0;
  border: none;

  ${({ showMobile }) =>
    showMobile &&
    css`
      @media (min-width: 1366px) {
        display: none;
        visibility: hidden;
      }
    `}

  margin-block: 56px;
  width: fit-content;
  > div {
    padding: 24px;
  }

  cursor: pointer;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;

  svg {
    margin-bottom: 8px;
  }
`;

export const IconWrapper = styled.div``;
